{
  "name": "microfox",
  "version": "1.0.15",
  "description": "Universal CLI tool for creating modern TypeScript packages with npm availability checking",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "bin": {
    "microfox": "./dist/cli.js"
  },
  "files": [
    "dist/**/*",
    "CHANGELOG.md"
  ],
  "scripts": {
    "build": "tsup",
    "build:watch": "tsup --watch",
    "clean": "rm -rf dist",
    "lint": "eslint \"./**/*.ts*\"",
    "prettier-check": "prettier --check \"./**/*.ts*\""
  },
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "dependencies": {
    "@types/micromatch": "^4.0.9",
    "axios": "^1.10.0",
    "chalk": "^5.3.0",
    "commander": "^14.0.0",
    "find-up": "^7.0.0",
    "inquirer": "^12.7.0",
    "js-yaml": "^4.1.0",
    "micromatch": "^4.0.8",
    "openapi-typescript": "^6.7.5",
    "readline-sync": "^1.4.10",
    "zod": "^4.0.5"
  },
  "devDependencies": {
    "@microfox/tracker": "^1.0.3",
    "@microfox/tsconfig": "*",
    "@types/inquirer": "^9.0.8",
    "@types/js-yaml": "^4.0.9",
    "@types/node": "^24.0.8",
    "@types/readline-sync": "^1.4.8",
    "tsup": "^8",
    "typescript": "5.8.3"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "homepage": "https://github.com/microfox-ai/microfox",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/microfox-ai/microfox.git"
  },
  "bugs": {
    "url": "https://github.com/microfox-ai/microfox/issues"
  },
  "keywords": [
    "microfox",
    "cli",
    "tool",
    "package-management",
    "typescript"
  ]
}
